import React, { useState, useRef } from 'react';
import screenfull from 'screenfull';

import { formatTime } from './VideoBlock.helpers';

import VideoBlock from './VideoBlock';

type VideoPlayerSeekRef = {
  seekTo: (amount: number, type: 'fraction') => void;
};

const VideoBlockContainer = ({
  data,
  ...restProps
}: { data: any } & Record<string, any>) => {
  const playerContainerRef = useRef();
  const playerRef = useRef<VideoPlayerSeekRef | null>(null);

  const [progress, setProgress] = useState({
    percent: 0,
    total: '0:00',
    current: '0:00',
  });

  const [playerSettings, setPlayerSettings] = useState({
    playing: false,
    muted: false,
    playbackRate: 1,
    volume: 1,
    fullScreen: false,
  });

  const handleProgress = ({
    playedSeconds,
    played,
    loadedSeconds,
  }: {
    playedSeconds: any;
    played: any;
    loadedSeconds: any;
  }) => {
    setProgress({
      percent: played,
      total: formatTime(loadedSeconds),
      current: formatTime(playedSeconds),
    });
  };

  const handleSettingsChange = (action: any, value: any) => {
    switch (action) {
      case 'PLAY_PAUSE': {
        setPlayerSettings((prevState: any) => ({
          ...prevState,
          playing: !prevState.playing,
        }));

        break;
      }
      case 'MUTE_UNMUTE': {
        setPlayerSettings((prevState: any) => ({
          ...prevState,
          muted: !prevState.muted,
          volume: prevState.muted ? 0.5 : 0,
        }));

        break;
      }
      case 'CHANGE_RATE': {
        setPlayerSettings((prevState: any) => ({
          ...prevState,
          playbackRate: value,
        }));

        break;
      }
      case 'CHANGE_VOLUME': {
        setPlayerSettings((prevState: any) => ({
          ...prevState,
          muted: value === 0,
          volume: value,
        }));

        break;
      }
      case 'CHANGE_TIMING': {
        playerRef.current?.seekTo(value, 'fraction');

        break;
      }
      case 'FULL_SCREEN': {
        screenfull.toggle(playerContainerRef.current);
        setPlayerSettings((prevState: any) => ({
          ...prevState,
          fullScreen: !prevState.fullScreen,
        }));

        break;
      }
    }
  };

  const handleLoopVideo = () => {
    setPlayerSettings({ ...playerSettings, playing: false });

    setTimeout(() => {
      setPlayerSettings({ ...playerSettings, playing: true });
    }, 2000);
  };

  return (
    <VideoBlock
      {...restProps}
      playerRef={playerRef}
      playerContainerRef={playerContainerRef}
      caption={data.caption}
      url={data.url}
      progress={progress}
      playerSettings={playerSettings}
      onProgress={handleProgress}
      onLoopVideo={handleLoopVideo}
      onSettingsChange={handleSettingsChange}
    />
  );
};

export default React.memo(VideoBlockContainer) as any;
